import React from "react";
import { Resource } from "react-admin";
import { appSecretsResource } from "resources/app-secrets";
import { clientNotificationDeliveriesResource } from "resources/client-notification-deliveries";
import { clientNotificationSubscriptionResource } from "resources/client-notification-subscription";
import { oAuth2RequestsResource } from "resources/oauth2-requests";
import { ordersByAPIResource } from "resources/orders-by-api";
import { thirdPartyAppsResource } from "resources/third-party-apps";

export const developerResources = [
	<Resource name="third-party-apps" {...thirdPartyAppsResource} />,
	<Resource name="app-secrets" {...appSecretsResource} />,
	<Resource name="terminal" intent="registration" />,
	<Resource name="oauth2-available-scopes" intent="registration" />,
	<Resource name="client-notification-subscriptions" {...clientNotificationSubscriptionResource} />,
	<Resource name="client-notification-deliveries" {...clientNotificationDeliveriesResource} />,
	<Resource name="orders-by-api" {...ordersByAPIResource} />,
	<Resource name="oauth2-requests" {...oAuth2RequestsResource} />,
];

export const developerRoutes = [];
